module.exports = __webpack_public_path__ + "static/img/华为 HUAWEI Watch GT 5.5227ebdb.png";